module.exports = __webpack_public_path__ + "media/application/images/2018/2018-twitter-icon-2b9202ab60b4653f69dd1254a50861ca.svg";